/* =============================================
   SB Filter Drawer – Accordion & Price Range
   ============================================= */

(function () {
  function initSbFilterDrawer() {
    // ---- Accordion ----
    document.querySelectorAll('[data-sb-accordion-toggle]').forEach(function (btn) {
      if (btn._sbInit) return;
      btn._sbInit = true;
      function toggleAccordion() {
        var accordion = btn.closest('[data-sb-accordion]');
        var isOpen = accordion.classList.contains('sb-accordion--open');
        accordion.classList.toggle('sb-accordion--open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      }
      btn.addEventListener('click', toggleAccordion);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleAccordion(); }
      });
    });

    // ---- Price range sliders ----
    document.querySelectorAll('.sb-price-range').forEach(function (wrapper) {
      if (wrapper._sbInit) return;
      wrapper._sbInit = true;

      var minRange = wrapper.querySelector('.sb-range-input--min');
      var maxRange = wrapper.querySelector('.sb-range-input--max');
      var fill = wrapper.querySelector('.sb-price-range__fill');
      var minLabel = wrapper.querySelector('.sb-price-display--min');
      var maxLabel = wrapper.querySelector('.sb-price-display--max');
      var minText = wrapper.querySelector('price-range .sb-price-text-input:first-of-type');
      var maxText = wrapper.querySelector('price-range .sb-price-text-input:last-of-type');

      if (!minRange || !maxRange) return;

      var rangeMax = parseFloat(wrapper.dataset.max) || 1000;

      function updateFill() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        var leftPct = (minVal / rangeMax) * 100;
        var widthPct = ((maxVal - minVal) / rangeMax) * 100;
        fill.style.left = leftPct + '%';
        fill.style.width = Math.max(0, widthPct) + '%';
      }

      function updateLabels() {
        if (minLabel) minLabel.textContent = Math.round(parseFloat(minRange.value));
        if (maxLabel) maxLabel.textContent = Math.round(parseFloat(maxRange.value));
      }

      minRange.addEventListener('input', function () {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (minVal > maxVal) { minRange.value = maxVal; minVal = maxVal; }
        updateFill();
        updateLabels();
        if (minText) {
          minText.value = Math.round(minVal);
          minText.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      maxRange.addEventListener('input', function () {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (maxVal < minVal) { maxRange.value = minVal; maxVal = minVal; }
        updateFill();
        updateLabels();
        if (maxText) {
          maxText.value = Math.round(maxVal);
          maxText.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });

      if (minText) {
        minText.addEventListener('change', function () {
          var val = Math.min(parseFloat(minText.value) || 0, parseFloat(maxRange.value));
          minRange.value = val;
          updateFill();
          updateLabels();
        });
      }

      if (maxText) {
        maxText.addEventListener('change', function () {
          var val = Math.max(parseFloat(maxText.value) || rangeMax, parseFloat(minRange.value));
          maxRange.value = val;
          updateFill();
          updateLabels();
        });
      }

      updateFill();
      updateLabels();
    });
  }

  // ---- Dimension range sliders (Width / Depth / Height metafields) ----
  function initSbDimRanges() {
    document.querySelectorAll('.sb-dim-range').forEach(function (wrapper) {
      if (wrapper._sbDimInit) return;
      wrapper._sbDimInit = true;

      var minRange = wrapper.querySelector('.sb-range-input--min');
      var maxRange = wrapper.querySelector('.sb-range-input--max');
      var fill = wrapper.querySelector('.sb-price-range__fill');
      var minLabel = wrapper.querySelector('.sb-price-display--min');
      var maxLabel = wrapper.querySelector('.sb-price-display--max');
      var minText = wrapper.querySelector('[data-role="dim-min-text"]');
      var maxText = wrapper.querySelector('[data-role="dim-max-text"]');
      var checkboxes = wrapper.querySelectorAll('.sb-dim-checkbox');

      if (!minRange || !maxRange || checkboxes.length === 0) return;

      var rangeMin = parseFloat(wrapper.dataset.min);
      var rangeMax = parseFloat(wrapper.dataset.max);
      var span = rangeMax - rangeMin;

      function updateFill() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (span === 0) return;
        var leftPct = ((minVal - rangeMin) / span) * 100;
        var widthPct = ((maxVal - minVal) / span) * 100;
        fill.style.left = leftPct + '%';
        fill.style.width = Math.max(0, widthPct) + '%';
      }

      function updateLabels(fromSlider) {
        var minVal = Math.round(parseFloat(minRange.value));
        var maxVal = Math.round(parseFloat(maxRange.value));
        if (minLabel) minLabel.textContent = minVal;
        if (maxLabel) maxLabel.textContent = maxVal;
        if (fromSlider) {
          if (minText) minText.value = minVal;
          if (maxText) maxText.value = maxVal;
        }
      }

      var debounceTimer;
      function syncCheckboxes() {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        var isFullRange = (minVal <= rangeMin && maxVal >= rangeMax);
        checkboxes.forEach(function (cb) {
          var val = parseFloat(cb.value);
          cb.checked = !isFullRange && (val >= minVal && val <= maxVal);
        });
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          checkboxes[0].dispatchEvent(new Event('change', { bubbles: true }));
        }, 400);
      }

      minRange.addEventListener('input', function () {
        if (parseFloat(minRange.value) > parseFloat(maxRange.value)) minRange.value = maxRange.value;
        updateFill(); updateLabels(true); syncCheckboxes();
      });

      maxRange.addEventListener('input', function () {
        if (parseFloat(maxRange.value) < parseFloat(minRange.value)) maxRange.value = minRange.value;
        updateFill(); updateLabels(true); syncCheckboxes();
      });

      if (minText) {
        minText.addEventListener('change', function () {
          var val = Math.max(rangeMin, Math.min(parseFloat(minText.value) || rangeMin, parseFloat(maxRange.value)));
          minRange.value = val;
          updateFill(); updateLabels(); syncCheckboxes();
        });
      }

      if (maxText) {
        maxText.addEventListener('change', function () {
          var val = Math.min(rangeMax, Math.max(parseFloat(maxText.value) || rangeMax, parseFloat(minRange.value)));
          maxRange.value = val;
          updateFill(); updateLabels(); syncCheckboxes();
        });
      }

      updateFill();
      updateLabels();
    });
  }

  function initAll() {
    initSbFilterDrawer();
    initSbDimRanges();
  }

  // Expose so facets.js can re-init after AJAX filter updates replace drawer innerHTML
  window.initSbFilterDrawer = initSbFilterDrawer;
  window.initSbDimRanges = initSbDimRanges;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the drawer opens (theme may render it lazily)
  document.addEventListener('on:menu-drawer:open', initAll);
  document.addEventListener('on:drawer:open', initAll);
})();



/* =============================================
   Balion: gjør hele produktkortet klikkbart
   Obtino-temaet lenker kun produkttittelen; bildet
   var ikke klikkbart noe sted på siden. 2026-08-27
   ============================================= */
(function () {
  function url(card) {
    return card.getAttribute('data-product-url');
  }
  document.addEventListener('click', function (e) {
    var card = e.target.closest('product-card[data-product-url]');
    if (!card) return;
    // ikke overstyr ekte lenker, knapper, fargevelgere eller skjemaer
    if (e.target.closest('a, button, input, label, select, form, [role="button"], .card__swatch, .swatchProductColor')) return;
    var media = e.target.closest('.card__media, .card__inner, .media');
    if (!media) return;
    var href = url(card);
    if (!href) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    window.location.href = href;
  });
  function markPointer() {
    document.querySelectorAll('product-card[data-product-url] .card__media').forEach(function (m) {
      m.style.cursor = 'pointer';
    });
  }
  document.addEventListener('DOMContentLoaded', markPointer);
  markPointer();
  new MutationObserver(markPointer).observe(document.documentElement, { childList: true, subtree: true });
})();


/* =============================================
   Balion: betalingsikoner i footer
   - legger inn Vipps (mangler i Shopifys ikonrad)
   - skjuler Union Pay og Maestro
   2026-08-27
   ============================================= */
(function () {
  var VIPPS = "https://balion.no/cdn/shop/t/22/assets/balion-vipps.svg";
  function fixPayments() {
    document.querySelectorAll('ul.list-payment').forEach(function (ul) {
      ul.querySelectorAll('li.list-payment__item').forEach(function (li) {
        var svg = li.querySelector('svg');
        var id = svg ? (svg.getAttribute('aria-labelledby') || '') : '';
        if (/pi-unionpay|pi-maestro/.test(id)) li.remove();
      });
      if (!ul.querySelector('.balion-vipps')) {
        var li = document.createElement('li');
        li.className = 'list-payment__item balion-vipps';
        var img = document.createElement('img');
        img.src = VIPPS;
        img.alt = 'Vipps';
        img.width = 38;
        img.height = 24;
        img.style.cssText = 'height:24px;width:auto;display:block;';
        li.appendChild(img);
        ul.insertBefore(li, ul.firstChild);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', fixPayments);
  fixPayments();
  new MutationObserver(fixPayments).observe(document.documentElement, { childList: true, subtree: true });
})();


/* =============================================
   Balion: Deep Fjord forhåndsvisning (23.10.26)
   - "Utsolgt" -> "Lanseres søndag" på deep-fjord-produkter
   - knappen åpner påmelding til nyhetsbrev (Klaviyo liste U6jQPe)
   - slår seg av automatisk søndag 25.10.26 kl. 19 (18:00 UTC)
   ============================================= */
(function () {
  if (Date.now() >= Date.parse('2026-10-25T18:00:00Z')) return;
  var LABEL = 'Lanseres søndag';
  var SOLD = /^(utsolgt|sold out)$/i;
  var isDF = function (s) { return /deep-fjord/.test(s || ''); };

  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Vd8rwd', {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Deep Fjord forhåndsvisning',
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: 'U6jQPe' } } } } })
    });
  }

  function buildForm() {
    var w = document.createElement('div');
    w.className = 'balion-df-signup';
    w.style.cssText = 'display:none;margin-top:12px;padding:16px;border:1px solid #1a1a1a;';
    w.innerHTML = '<p style="margin:0 0 10px;font-size:14px;line-height:1.5;">Få beskjed når Deep Fjord er ute.</p>' +
      '<form style="display:flex;gap:8px;flex-wrap:wrap;">' +
      '<input type="email" required placeholder="Din e-post" aria-label="E-post" style="flex:1 1 180px;min-height:44px;padding:0 12px;border:1px solid #1a1a1a;font-size:16px;">' +
      '<button type="submit" class="button button--primary" style="min-height:44px;">Meld meg på</button></form>' +
      '<p class="balion-df-msg" style="margin:10px 0 0;font-size:13px;"></p>';
    var f = w.querySelector('form'), msg = w.querySelector('.balion-df-msg');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = f.querySelector('input').value.trim();
      msg.textContent = 'Sender...';
      subscribe(em).then(function (r) {
        if (r.ok || r.status === 202) { f.style.display = 'none'; msg.textContent = 'Takk. Du hører fra oss på søndag.'; }
        else { msg.textContent = 'Noe gikk galt. Prøv igjen.'; }
      }).catch(function () { msg.textContent = 'Noe gikk galt. Prøv igjen.'; });
    });
    return w;
  }

  function fixPDP() {
    if (!isDF(location.pathname) || location.pathname.indexOf('/products/') < 0) return;
    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      var span = btn.querySelector('span') || btn;
      if (span.textContent.trim() !== LABEL) span.textContent = LABEL;
      if (btn.dataset.balionDf) return;
      btn.dataset.balionDf = '1';
      var box = btn.closest('.product-form__buttons') || btn.parentNode;
      var form = buildForm();
      box.parentNode.insertBefore(form, box.nextSibling);
      var pay = box.querySelector('.shopify-payment-button'); if (pay) pay.style.display = 'none';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        form.style.display = form.style.display === 'none' ? 'block' : 'none';
        if (form.style.display === 'block') { var i = form.querySelector('input'); if (i) i.focus(); }
      }, true);
    });
    document.querySelectorAll('.product-form__submit[disabled]').forEach(function (b) { b.removeAttribute('disabled'); b.style.cursor = 'pointer'; });
  }

  function fixCards() {
    document.querySelectorAll('a.full-unstyled-link[href*="deep-fjord"]').forEach(function (a) {
      var card = a.closest('.card-wrapper');
      if (!card) return;
      if (!card.classList.contains('balion-df-card')) card.classList.add('balion-df-card');
      card.querySelectorAll('.badge').forEach(function (el) { if (el.textContent.trim() === LABEL && !el.classList.contains('balion-df-badge')) el.classList.add('balion-df-badge'); });
      card.querySelectorAll('.badge, span, button').forEach(function (el) {
        if (el.children.length === 0 && SOLD.test(el.textContent.trim())) el.textContent = LABEL;
      });
    });
  }

  function addStyle() {
    if (document.getElementById('balion-df-style') || !document.head) return;
    var st = document.createElement('style'); st.id = 'balion-df-style';
    st.textContent = '.balion-df-badge{background:#1a1a1a !important;color:#fff !important;border-color:#1a1a1a !important;}' +
      '.balion-df-card .card__size-option, .balion-df-card .card__size-option--sold-out{text-decoration:none !important;opacity:1 !important;}' +
      'body.balion-df-pdp variant-selects label, body.balion-df-pdp variant-radios label{text-decoration:none !important;opacity:1 !important;}';
    document.head.appendChild(st);
  }
  function fixPDPBadge() {
    if (!isDF(location.pathname) || location.pathname.indexOf('/products/') < 0) return;
    if (document.body) document.body.classList.add('balion-df-pdp');
    document.querySelectorAll('.price__badge-sold-out').forEach(function (el) {
      if (el.closest('.card-wrapper')) return;
      if (el.textContent.trim() !== LABEL) el.textContent = LABEL;
      el.classList.add('balion-df-badge');
    });
  }
  function run() { try { addStyle(); fixPDP(); fixPDPBadge(); fixCards(); } catch (e) {} }
  document.addEventListener('DOMContentLoaded', run);
  run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
